export const LEA_PORTAL_CONSTANT={
    LEA_TEMPLATE:"LEA_Template",
    LEA_SUBMISSION:"LEA"
}